import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const DownloadReport = () => {
  const [selectedDate, setSelectedDate] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDownload, setShowDownload] = useState(false);

  const formatDateRange = (date) => {
    const formatted = date.split("-").reverse().join("/");
    return `${formatted} 00:00:00_${formatted} 23:59:59`;
  };

  const fetchReport = async () => {
    if (!selectedDate) {
      alert("Please select date");
      return;
    }

    try {
      setLoading(true);
      setShowDownload(false);

      const dateRange = formatDateRange(selectedDate);

      const response = await axios.post(
        "https://admin.westrova.com/backend/ns-pay/v1/payin/download-report",
        { dateRange },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.data.status) {
        const data = response.data.data.data;
        setTransactions(data);
        setShowDownload(true);
      } else {
        alert("No data found");
      }
    } catch (error) {
      console.error(error);
      alert("Error fetching report");
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = () => {
    const formattedData = transactions.map((item) => ({
      TransactionID: item.transactionId,
      RefID: item.refId,
      Status: item.status,
      Amount: item.amount,
      BankUTR: item.bankUtr,
      UPI: item.beneDetails?.upiId || "",
      Remark: item.beneDetails?.remark || "",
      CreatedAt: item.createdAt,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    XLSX.writeFile(workbook, `Transaction_Report_${selectedDate}.xlsx`);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f6f9",
        padding: "40px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "auto",
          background: "#ffffff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ marginBottom: "20px", color: "#2c3e50" }}>
          Payin Transaction Report
        </h2>

        {/* Date Section */}
        <div style={{ display: "flex", gap: "15px", marginBottom: "25px" }}>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />

          <button
            onClick={fetchReport}
            style={{
              background: "#3498db",
              color: "#fff",
              padding: "10px 18px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {loading ? "Fetching..." : "Fetch Report"}
          </button>

          {showDownload && (
            <button
              onClick={downloadExcel}
              style={{
                background: "#27ae60",
                color: "#fff",
                padding: "10px 18px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Download Excel
            </button>
          )}
        </div>

        {/* Table */}
        {transactions.length > 0 && (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ background: "#f1f3f6" }}>
                  <th style={thStyle}>Txn ID</th>
                  <th style={thStyle}>Status</th>
                  <th style={thStyle}>Amount</th>
                  <th style={thStyle}>Bank UTR</th>
                  <th style={thStyle}>Remark</th>
                  <th style={thStyle}>Created At</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((item, index) => (
                  <tr key={index} style={{ textAlign: "center" }}>
                    <td style={tdStyle}>{item.transactionId}</td>
                    <td
                      style={{
                        ...tdStyle,
                        color:
                          item.status === "CREDITED"
                            ? "green"
                            : item.status === "FAILED"
                            ? "red"
                            : "orange",
                        fontWeight: "bold",
                      }}
                    >
                      {item.status}
                    </td>
                    <td style={tdStyle}>₹ {item.amount}</td>
                    <td style={tdStyle}>{item.bankUtr}</td>
                    <td style={tdStyle}>
                      {item.beneDetails?.remark || ""}
                    </td>
                    <td style={tdStyle}>
                      {new Date(item.createdAt).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const thStyle = {
  padding: "12px",
  borderBottom: "1px solid #ddd",
  fontWeight: "bold",
};

const tdStyle = {
  padding: "10px",
  borderBottom: "1px solid #eee",
};

export default DownloadReport;